import { CardContent, CardMedia, Grid, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { Button, Modal } from '../../../../components';
import {
  useDispatch,
  useSelector,
  privateHistorySlice,
} from '../../../../stores';
import { handleMoney } from '../../../../utils';
import { StyledButtonsWrapper, StyledModalWrapper } from '../styles';
import 'react-credit-cards/es/styles-compiled.css';

export const PrivateTicketDetailsModal: React.FC = () => {
  const dispatch = useDispatch();
  const { driverId, email, name } = useSelector(
    (state) => state.profileReducer,
  );
  const {
    privateTicketDetails,
    privateTicketDetailsIsOpen,
    privateTicketDetailsIsLoading,
  } = useSelector((state) => state.privateHistoryReducer);

  const handleClose = () => {
    dispatch(privateHistorySlice.actions.togglePrivateTicketDetailsIsOpen());
  };

  return (
    <Modal
      open={privateTicketDetailsIsOpen}
      onClose={handleClose}
      title={'Detalhes do ticket ' + privateTicketDetails?.parkingTicketId}
      isLoading={privateTicketDetailsIsLoading}
    >
      <StyledModalWrapper>
        <Grid
          item
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'stretch',
          }}
        >
          {/* 
          privateParkingId: number;
          pixCode: string | null; */}
          <CardContent>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                  noWrap
                >
                  Estacionamento:&nbsp;
                </Typography>
                {/* <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                  }}
                  noWrap
                >
                  {privateTicketDetails?.privateParkingName}
                </Typography> */}
              </Grid>
              <Grid item xs={12}>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                  noWrap
                >
                  Horário do registro:&nbsp;
                </Typography>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                  }}
                  noWrap
                >
                  {moment(privateTicketDetails?.registerDateTime).format(
                    'DD/MM/yyyy HH:mm:ss',
                  )}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                  noWrap
                >
                  Horário inicial:&nbsp;
                </Typography>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                  }}
                  noWrap
                >
                  {moment(privateTicketDetails?.startDateTime).format(
                    'DD/MM/yyyy HH:mm:ss',
                  )}
                </Typography>
              </Grid>
              {/* <Grid item xs={12}>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                  noWrap
                >
                  Horário final:&nbsp;
                </Typography>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                  }}
                  noWrap
                >
                  {moment(privateTicketDetails?.exitDateTime).format(
                    'DD/MM/yyyy HH:mm:ss',
                  )}
                </Typography>
              </Grid> */}
            </Grid>
            <Grid container sx={{ marginTop: 2 }}>
              <Grid item xs={12}>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                  noWrap
                >
                  Placa:&nbsp;
                </Typography>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                  }}
                  noWrap
                >
                  {privateTicketDetails?.plate}
                </Typography>
              </Grid>
              {/* <Grid item xs={12}>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                  noWrap
                >
                  Período:&nbsp;
                </Typography>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                  }}
                  noWrap
                >
                  {moment(privateTicketDetails?.exitTime).diff(
                    moment(privateTicketDetails?.entryTime),
                  )}
                </Typography>
              </Grid> */}
              <Grid item xs={12}>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                  noWrap
                >
                  Valor:&nbsp;
                </Typography>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                  }}
                  noWrap
                >
                  {handleMoney(privateTicketDetails?.price)} (
                  <Typography
                    color='primary'
                    sx={{
                      fontSize: '0.75em',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                    }}
                    noWrap
                  >
                    {privateTicketDetails?.paymentType}
                  </Typography>
                  )
                </Typography>
              </Grid>
            </Grid>
            {privateTicketDetails?.paymentType !== 'PIX' && (
              <Grid container sx={{ marginTop: 2 }}>
                <Grid item xs={12}>
                  <Typography
                    color='primary'
                    sx={{
                      fontSize: '0.75em',
                      fontWeight: 'bold',
                    }}
                    noWrap
                  >
                    Pago pelo aplicativo:
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    color='primary'
                    sx={{
                      fontSize: '0.75em',
                      fontWeight: 'bold',
                    }}
                    noWrap
                  >
                    Cartão:&nbsp;
                  </Typography>
                  {/* <Typography
                    color='primary'
                    sx={{
                      fontSize: '0.75em',
                    }}
                    noWrap
                  >
                    **** {privateTicketDetails?.cardNumber} (
                    <Typography
                      color='primary'
                      sx={{
                        fontSize: '0.75em',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                      }}
                      noWrap
                    >
                      {privateTicketDetails?.cardBrand}
                    </Typography>
                    )
                  </Typography> */}
                </Grid>
              </Grid>
            )}
          </CardContent>
        </Grid>
        {/* <StyledButtonsWrapper>
          <Button
            variant='contained'
            label='Enviar por email'
            type='submit'
            onClick={handleSendTicketByEmail}
            color='secondary'
            loading={sendTicketByEmailLoading}
            style={{ width: '100%' }}
          />
        </StyledButtonsWrapper> */}
      </StyledModalWrapper>
    </Modal>
  );
};
